// @generated by protoc-gen-zod-es v0.0.1 with parameter "target=ts,import_extension=none"
// @generated from file tenki/cloud/identity/v1beta1/identity.proto (package tenki.cloud.identity.v1beta1, syntax proto3)
/* eslint-disable */

import { z } from "zod";

/**
 * @generated from message tenki.cloud.identity.v1beta1.User
 */
export const userSchema = z.object({
  userId: z.string(),
  email: z.string(),
  firstName: z.string().optional(),
  lastName: z.string().optional(),
  avatarUrl: z.string().optional(),
  hasPassword: z.boolean(),
  hasOidcGithub: z.boolean(),
  avatarBgColor: z.string().optional(),
  isVerified: z.boolean(),
  hasTwoFa: z.boolean(),
  isChecklistComplete: z.boolean(),
});
